import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import PlayerRank from '../../components/PlayerRank';

const PeringkatWanitaPage = () => {
  const [selectedLevel, setSelectedLevel] = useState('All');

  const handleLevelChange = (event) => {
    setSelectedLevel(event.target.value);
  };

  const players = [
    { rank: 1, name: 'Maria Santos', wins: 13, losses: 3, points: 2280, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-5.jpg', level: 'Advanced' },
    { rank: 2, name: 'Sofia Chen', wins: 11, losses: 5, points: 1980, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-6.jpg', level: 'Advanced' },
    { rank: 3, name: 'Isabella Rossi', wins: 10, losses: 6, points: 1720, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-1.jpg', level: 'Intermediate' },
    { rank: 4, name: 'Jane Doe', wins: 9, losses: 7, points: 1650, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-14.jpg', level: 'Intermediate' },
    { rank: 5, name: 'Mary Johnson', wins: 8, losses: 8, points: 1550, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-15.jpg', level: 'Intermediate' },
    { rank: 6, name: 'Patricia Williams', wins: 7, losses: 9, points: 1450, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-16.jpg', level: 'Beginner' },
    { rank: 7, name: 'Jennifer Brown', wins: 6, losses: 10, points: 1350, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-17.jpg', level: 'Beginner' },
    { rank: 8, name: 'Linda Davis', wins: 5, losses: 11, points: 1250, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-18.jpg', level: 'Beginner' },
    { rank: 9, name: 'Elizabeth Miller', wins: 4, losses: 12, points: 1150, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-19.jpg', level: 'Beginner' },
    { rank: 10, name: 'Barbara Wilson', wins: 3, losses: 13, points: 1050, avatar: 'https://storage.googleapis.com/uxpilot-auth.appspot.com/avatars/avatar-20.jpg', level: 'Beginner' },
  ];

  const filteredPlayers = selectedLevel === 'All' ? players : players.filter(player => player.level === selectedLevel);

  return (
    <div className="bg-brand-dark text-white font-custom min-h-screen">
      <header className="bg-black/30 backdrop-blur-md">
        <div className="container mx-auto px-6 py-4 flex justify-between items-center">
          <Link to="/" className="flex items-center">
            <h1 className="text-3xl font-extrabold text-brand-lime tracking-tighter">5.AM</h1>
            <span className="text-xl font-semibold text-white ml-2 tracking-wide">Padel Club</span>
          </Link>
        </div>
      </header>

      <main className="py-12">
        <div className="container mx-auto px-6">
          <h2 className="text-4xl font-extrabold text-white text-center mb-8">Peringkat Pemain Wanita</h2>
          <div className="mb-6 text-center">
            <label htmlFor="level-select" className="mr-4 text-lg font-semibold">Level:</label>
            <select
              id="level-select"
              value={selectedLevel}
              onChange={handleLevelChange}
              className="bg-brand-dark border border-brand-terracotta/30 rounded-md py-2 px-4 text-white focus:outline-none focus:ring-2 focus:ring-brand-lime"
            >
              <option value="All">All</option>
              <option value="Beginner">Beginner</option>
              <option value="Intermediate">Intermediate</option>
              <option value="Advanced">Advanced</option>
            </select>
          </div>
          <div className="bg-brand-dark rounded-xl p-8 border border-brand-terracotta/30">
            <div className="space-y-4">
              {filteredPlayers.map((player) => (
                <PlayerRank
                  key={player.rank}
                  rank={player.rank}
                  name={player.name}
                  points={player.points}
                  avatar={player.avatar}
                  isTopRank={player.rank === 1}
                />
              ))}
            </div>
          </div>
          <div className="text-center mt-8">
            <Link to="/" className="text-brand-lime hover:underline">Kembali ke Halaman Utama</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default PeringkatWanitaPage;